"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupBoardSyncListeners = exports.matchBoardUpdateAction = exports.benchUpdateAction = exports.boardUpdateAction = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const updateBoardFromPacket_1 = require("~/networking/utils/updateBoardFromPacket");
const commands_1 = require("../battle/commands");
exports.boardUpdateAction = (0, toolkit_1.createAction)("boardUpdateAction");
exports.benchUpdateAction = (0, toolkit_1.createAction)("benchUpdateAction");
exports.matchBoardUpdateAction = (0, toolkit_1.createAction)("matchBoardUpdateAction");
const setupBoardSyncListeners = (startListening) => {
    startListening({
        actionCreator: exports.boardUpdateAction,
        effect: ({ payload }, api) => {
            const { board, pieceRegistry } = api.extra.sessionHolder.get();
            (0, updateBoardFromPacket_1.updateBoardFromPacket)(board, pieceRegistry, payload);
        },
    });
    startListening({
        actionCreator: exports.benchUpdateAction,
        effect: ({ payload }, api) => {
            const { bench, pieceRegistry } = api.extra.sessionHolder.get();
            (0, updateBoardFromPacket_1.updateBoardFromPacket)(bench, pieceRegistry, payload);
        },
    });
    startListening({
        actionCreator: exports.matchBoardUpdateAction,
        // Mutation must complete before startBattleCommand fires.
        effect: ({ payload }, api) => {
            const { battle, pieceRegistry } = api.extra.sessionHolder.get();
            (0, updateBoardFromPacket_1.updateBoardFromPacket)(battle.board, pieceRegistry, payload.board);
            if (payload.turn !== null) {
                api.dispatch((0, commands_1.startBattleCommand)({ turn: payload.turn }));
            }
        },
    });
};
exports.setupBoardSyncListeners = setupBoardSyncListeners;
